// Bilingual translations for Sri Venkateswara Rice Mill
export const translations = {
  en: {
    nav: {
      home: "Home",
      products: "Products",
      about: "About",
      contact: "Contact",
      cart: "Cart",
      admin: "Admin",
    },
    common: {
      orderNow: "Order Now",
      addToCart: "Add to Cart",
      added: "Added",
      perKg: "per kg",
      kg: "kg",
      total: "Total",
      subtotal: "Subtotal",
      checkout: "Checkout",
      back: "Back",
      remove: "Remove",
      empty: "Your cart is empty",
      browseProducts: "Browse Products",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      addProduct: "Add Product",
    },
    home: {
      tag: "Trusted since generations",
      heroTitle: "Pure rice, milled with pride in F. K. Palem",
      heroSub: "Family-run rice mill serving wholesale buyers and households across Andhra Pradesh. Sona Masuri, HMT, BPT, RNR and more — straight from our mill.",
      cta1: "Shop Rice",
      cta2: "Talk on WhatsApp",
      whyTitle: "Why buyers choose us",
      why1Title: "Mill-direct freshness",
      why1Desc: "Every bag is milled and polished in-house. No middlemen, no stale stock.",
      why2Title: "Wholesale & retail",
      why2Desc: "5 kg household packs to 50 kg wholesale bags. Bulk pricing for hotels & traders.",
      why3Title: "Doorstep delivery",
      why3Desc: "Fast local delivery and pan-India dispatch. Pay online or on delivery.",
      productsTitle: "Our rice varieties",
      productsSub: "All varieties stone-cleaned, sortexed and freshly polished.",
      viewAll: "View all products",
      ctaTitle: "Need a custom bulk order?",
      ctaSub: "Hotels, restaurants, traders — get the best wholesale rates today.",
      ctaBtn: "Get a quote on WhatsApp",
    },
    products: {
      title: "Our Products",
      sub: "Choose your variety and pack size — fresh from our mill.",
      selectWeight: "Pack size",
    },
    cart: {
      title: "Your Cart",
      item: "Item",
      qty: "Qty",
      price: "Price",
      proceed: "Proceed to Checkout",
    },
    checkout: {
      title: "Checkout",
      name: "Full name",
      phone: "Phone number",
      address: "Delivery address",
      notes: "Notes (optional)",
      paymentMethod: "Payment method",
      whatsapp: "Order on WhatsApp (pay on delivery)",
      razorpay: "Pay online (Coming soon)",
      placeOrder: "Place Order",
      sending: "Sending...",
      successTitle: "Order placed!",
      successMsg: "We've received your order. Opening WhatsApp to confirm...",
    },
    contact: {
      title: "Get in touch",
      sub: "Have a question or want a bulk quote? Reach out — we usually reply within minutes on WhatsApp.",
      address: "Address",
      phone: "Phone / WhatsApp",
      hours: "Working hours",
      hoursValue: "Mon – Sat, 8:00 AM – 7:00 PM",
    },
    admin: {
      login: "Admin Login",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Admin Dashboard",
      products: "Products",
      orders: "Orders",
      logout: "Logout",
      noOrders: "No orders yet.",
      customer: "Customer",
      itemsCount: "Items",
      amount: "Amount",
      status: "Status",
      date: "Date",
    },
    footer: {
      tagline: "Family-run rice mill, milling pure rice with traditional care since generations.",
      quickLinks: "Quick links",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
  te: {
    nav: {
      home: "హోమ్",
      products: "ఉత్పత్తులు",
      about: "మా గురించి",
      contact: "సంప్రదించండి",
      cart: "కార్ట్",
      admin: "నిర్వాహకుడు",
    },
    common: {
      orderNow: "ఇప్పుడే ఆర్డర్ చేయండి",
      addToCart: "కార్ట్‌కు జోడించు",
      added: "జోడించబడింది",
      perKg: "కిలోకి",
      kg: "కిలో",
      total: "మొత్తం",
      subtotal: "ఉప మొత్తం",
      checkout: "చెక్‌అవుట్",
      back: "వెనుకకు",
      remove: "తొలగించు",
      empty: "మీ కార్ట్ ఖాళీగా ఉంది",
      browseProducts: "ఉత్పత్తులను చూడండి",
      loading: "లోడ్ అవుతోంది...",
      save: "సేవ్",
      cancel: "రద్దు",
      delete: "తొలగించు",
      edit: "మార్చు",
      addProduct: "ఉత్పత్తి జోడించు",
    },
    home: {
      tag: "తరతరాలుగా విశ్వసనీయం",
      heroTitle: "ఎఫ్. కె. పాలెం నుండి స్వచ్ఛమైన బియ్యం",
      heroSub: "ఆంధ్రప్రదేశ్ అంతటా టోకు కొనుగోలుదారులు మరియు ఇంటి అవసరాలకు మా కుటుంబ రైస్ మిల్లు. సోనా మసూరి, HMT, BPT, RNR — మిల్లు నుండి నేరుగా.",
      cta1: "బియ్యం కొనండి",
      cta2: "వాట్సాప్ లో మాట్లాడండి",
      whyTitle: "మమ్మల్ని ఎందుకు ఎంచుకుంటారు",
      why1Title: "మిల్లు నేరుగా తాజాదనం",
      why1Desc: "ప్రతి సంచి మా మిల్లులోనే పాలిష్ చేయబడుతుంది. మధ్యవర్తులు లేరు.",
      why2Title: "టోకు & చిల్లర",
      why2Desc: "5 కిలోల ప్యాక్ నుండి 50 కిలోల టోకు సంచుల వరకు. హోటళ్లకు ప్రత్యేక ధరలు.",
      why3Title: "ఇంటి వరకు డెలివరీ",
      why3Desc: "స్థానిక డెలివరీ, దేశవ్యాప్త రవాణా. ఆన్‌లైన్ లేదా డెలివరీ సమయంలో చెల్లించండి.",
      productsTitle: "మా బియ్యం రకాలు",
      productsSub: "అన్ని రకాలు రాయి తీసి, సార్టెక్స్ చేసి తాజాగా పాలిష్ చేయబడ్డాయి.",
      viewAll: "అన్ని ఉత్పత్తులను చూడండి",
      ctaTitle: "పెద్ద మొత్తం కావాలా?",
      ctaSub: "హోటళ్లు, రెస్టారెంట్లు, వ్యాపారులు — ఉత్తమ టోకు ధరలు పొందండి.",
      ctaBtn: "వాట్సాప్ లో కోట్ తీసుకోండి",
    },
    products: {
      title: "మా ఉత్పత్తులు",
      sub: "మీ రకాన్ని, ప్యాక్ సైజును ఎంచుకోండి — మిల్లు నుండి తాజాగా.",
      selectWeight: "ప్యాక్ సైజు",
    },
    cart: {
      title: "మీ కార్ట్",
      item: "వస్తువు",
      qty: "పరిమాణం",
      price: "ధర",
      proceed: "చెక్‌అవుట్ కు వెళ్ళండి",
    },
    checkout: {
      title: "చెక్‌అవుట్",
      name: "పూర్తి పేరు",
      phone: "ఫోన్ నంబర్",
      address: "డెలివరీ చిరునామా",
      notes: "గమనికలు (ఐచ్ఛికం)",
      paymentMethod: "చెల్లింపు పద్ధతి",
      whatsapp: "వాట్సాప్ ఆర్డర్ (డెలివరీ సమయంలో చెల్లింపు)",
      razorpay: "ఆన్‌లైన్ చెల్లింపు (త్వరలో)",
      placeOrder: "ఆర్డర్ ఇవ్వండి",
      sending: "పంపుతోంది...",
      successTitle: "ఆర్డర్ ఇవ్వబడింది!",
      successMsg: "మీ ఆర్డర్ స్వీకరించాము. వాట్సాప్ తెరుస్తున్నాము...",
    },
    contact: {
      title: "మమ్మల్ని సంప్రదించండి",
      sub: "ప్రశ్నలు లేదా టోకు ధరల కోసం వాట్సాప్ లో సంప్రదించండి.",
      address: "చిరునామా",
      phone: "ఫోన్ / వాట్సాప్",
      hours: "పని వేళలు",
      hoursValue: "సోమ – శని, ఉ. 8:00 – సా. 7:00",
    },
    admin: {
      login: "నిర్వాహకుడి లాగిన్",
      email: "ఇమెయిల్",
      password: "పాస్‌వర్డ్",
      signIn: "సైన్ ఇన్",
      dashboard: "నిర్వాహకుడి డాష్‌బోర్డ్",
      products: "ఉత్పత్తులు",
      orders: "ఆర్డర్లు",
      logout: "లాగౌట్",
      noOrders: "ఇంకా ఆర్డర్లు లేవు.",
      customer: "కస్టమర్",
      itemsCount: "వస్తువులు",
      amount: "మొత్తం",
      status: "స్థితి",
      date: "తేదీ",
    },
    footer: {
      tagline: "తరతరాలుగా సాంప్రదాయిక శ్రద్ధతో స్వచ్ఛమైన బియ్యాన్ని మిల్లింగ్ చేస్తున్న కుటుంబ రైస్ మిల్లు.",
      quickLinks: "త్వరిత లింకులు",
      contact: "సంప్రదించండి",
      rights: "అన్ని హక్కులూ రిజర్వ్ చేయబడ్డాయి.",
    },
  },
};

export const WEIGHT_OPTIONS = [5, 10, 25, 50];
